import { defineMessages } from "react-intl";

export const homePageMessages = defineMessages({
  salesCardTitle: {
    defaultMessage: "Sales",
    id: "c8nvms",
  },
  outOfStockCardTitle: {
    defaultMessage: "Out of stock",
    id: "WHgdsk",
  },
});
